module.exports = __webpack_public_path__ + "static/media/logo.7871e171.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Menu/logo.svg
// module id = 67
// module chunks = 0